import { Injectable, computed, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';
import { RightsService } from '../auth/rights.service';
import { ExternalPortal } from './external-portal-context';

export type PortalAccessState =
  | { readonly kind: 'loading' }
  | { readonly kind: 'denied'; readonly message: string }
  | { readonly kind: 'error'; readonly message: string }
  | { readonly kind: 'ready'; readonly portals: readonly ExternalPortal[] };

@Injectable({ providedIn: 'root' })
export class PortalPersonaService {
  private readonly oidc = inject(OidcSecurityService);
  private readonly rights = inject(RightsService);

  readonly state = computed<PortalAccessState>(() => {
    if (!this.oidc.authenticated().isAuthenticated || !this.rights.loaded()) return { kind: 'loading' };
    if (this.rights.accessDenied()) return { kind: 'denied', message: 'Your account is not provisioned for IDR.' };
    if (this.rights.error()) return { kind: 'error', message: 'We could not verify your IDR access. Try signing in again.' };
    if (environment.reviewMode) return { kind: 'ready', portals: ['party', 'reviewer'] };

    const roles = new Set(this.rights.roles().map((role) => role.toLowerCase()));
    const portals: ExternalPortal[] = [];
    if (roles.has('idruser')) portals.push('party');
    if (roles.has('reviewer')) portals.push('reviewer');

    return portals.length > 0 ? { kind: 'ready', portals } : { kind: 'denied', message: 'Your account does not have an IDR Party or Reviewer role.' };
  });

  canEnter(portal: ExternalPortal): boolean {
    const state = this.state();
    return state.kind === 'ready' && state.portals.includes(portal);
  }
}
